module.exports = __webpack_public_path__ + "static/img/FuLin_Banner_autumn.a6202aa3.jpg";